import React, { memo } from 'react'
import { useWatch } from 'react-hook-form'
import Grid from 'transfix-ui/core/Grid'
import Typography from 'transfix-ui/core/Typography'
import { Maybe } from 'types/graphqlTypes'
import { IShipmentCoverActorFragment } from '../../../graphql/ShipmentActorFragment'
import { useCoverModalFormContext } from '../../../hooks/useCoverModalForm'
import { ICoverInfoCarrier } from '../../../types'
import ControlledRadioDriverAssignation from '../../controlled/ControlledRadioDriverAssignation'
import AssignDriverLaterInputGroup from './AssignDriverLaterInputGroup'
import AssignDriverNowInputGroup from './AssignDriverNowInputGroup'

export interface IDriverInformationFormGroupProps {
  selectedCarrier: Maybe<ICoverInfoCarrier>
  pickupTime: string
  shipmentTimezone: string
  driver: Maybe<IShipmentCoverActorFragment>
}

const DriverInformationFormGroup = memo<IDriverInformationFormGroupProps>(
  ({ driver, pickupTime, selectedCarrier, shipmentTimezone }) => {
    /**
     * Form Context
     */
    const { control, errors, setValue } = useCoverModalFormContext()
    const assignDriverTime = useWatch({ control, name: 'assignDriverTime' })

    const { id: carrierId } = selectedCarrier || { id: '' }

    return (
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant='subtitle1'>Assign a Driver</Typography>
        </Grid>
        <Grid item xs={12}>
          <ControlledRadioDriverAssignation
            name='assignDriverTime'
            control={control}
            disabled={!carrierId}
          />
        </Grid>
        {assignDriverTime === 'now' && (
          <Grid item xs={12}>
            <AssignDriverNowInputGroup
              control={control}
              errors={errors}
              setValue={setValue}
              selectedCarrier={selectedCarrier}
              pickupTime={pickupTime}
              shipmentTimezone={shipmentTimezone}
              driver={driver}
            />
          </Grid>
        )}
        {assignDriverTime === 'later' && (
          <Grid item xs={12}>
            <AssignDriverLaterInputGroup control={control} errors={errors} />
          </Grid>
        )}
      </Grid>
    )
  }
)

export default DriverInformationFormGroup
